import { render, staticRenderFns } from "./MenuListItem.vue?vue&type=template&id=7dfbd5dc&scoped=true&"
import script from "./MenuListItem.vue?vue&type=script&lang=js&"
export * from "./MenuListItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuListItem.vue?vue&type=style&index=0&id=7dfbd5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfbd5dc",
  null
  
)

export default component.exports